export enum COOKIE_STORAGE_KEYS {
  JWT_TOKEN = "JWT_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN"
}
